import { render, staticRenderFns } from "./UploadSlip.vue?vue&type=template&id=59a26355&scoped=true&"
import script from "./UploadSlip.vue?vue&type=script&lang=js&"
export * from "./UploadSlip.vue?vue&type=script&lang=js&"
import style0 from "./UploadSlip.vue?vue&type=style&index=0&id=59a26355&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a26355",
  null
  
)

export default component.exports